import type { Disposable, Model } from '@patsnap/tahiti-core';
import type { CurrentMatchedPatentState } from '../types';

/**
 * 当前匹配专利排行榜模型
 * @description 存储当前匹配专利排行榜状态
 */
export interface FtoReportCurrentMatchedPatentModel extends Model<CurrentMatchedPatentState>, Disposable {

}

export const FtoReportCurrentMatchedPatentModel = Symbol.for('FtoReportCurrentMatchedPatentModel');
